var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDemograficos = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "20px",
    viewBox: "0 0 17 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.5,20 L1.5,12.5 L0,12.5 L0,7 C0,5.9 0.9,5 2,5 L5,5 C6.1,5 7,5.9 7,7 L7,12.5 L5.5,12.5 L5.5,20 L1.5,20 L1.5,20 Z M14,20 L14,14 L17,14 L14.46,6.37 C14.18,5.55 13.42,5 12.56,5 L12.44,5 C11.58,5 10.81,5.55 10.54,6.37 L8,14 L11,14 L11,20 L14,20 L14,20 Z M3.5,4 C4.61,4 5.5,3.11 5.5,2 C5.5,0.89 4.61,0 3.5,0 C2.39,0 1.5,0.89 1.5,2 C1.5,3.11 2.39,4 3.5,4 L3.5,4 Z M12.5,4 C13.61,4 14.5,3.11 14.5,2 C14.5,0.89 13.61,0 12.5,0 C11.39,0 10.5,0.89 10.5,2 C10.5,3.11 11.39,4 12.5,4 L12.5,4 Z",
    id: "path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Salida-datos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inicio-selecci\\xF3n-multiple-de-eventos-copy-19",
    transform: "translate(-20.000000, -574.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_wc",
    transform: "translate(20.000000, 574.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#757575",
    xlinkHref: "#path-2"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDemograficos, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/demograficos.c88364ae.svg";
export { ForwardRef as ReactComponent };